import { TReduxActions } from '../../types/redux';
import { IDrawingState } from '../../types/drawing';
import { EDrawingActionType } from '../../actions/drawing';
import { ERulerActionType } from '../../actions/ruler';

const defaultState: IDrawingState = {
  isDrawingMode: false,
};

export function drawingReducer(state: IDrawingState = defaultState, action: TReduxActions): IDrawingState {
  switch (action.type) {
    case EDrawingActionType.DrawingStarted:
      return {
        ...state,
        isDrawingMode: true,
      };
    case EDrawingActionType.DrawingFinished:
    case ERulerActionType.RulerEnabled:
      return {
        ...state,
        isDrawingMode: false,
      };
    default:
      return state;
  }
}
